export default function Loader({ isLoaded = false, siteConfig }) {
    const defaultLoaderConfig = {
        animation: ["P", "O", "L", "N"],
        message:
            "NETWORK",
        loadMessage:
            "Loading"
    }

    const lc = siteConfig?.loaderConfig || defaultLoaderConfig;

	return (
        <div id="preloader" className={`preloader ${isLoaded ? 'loaded' : ''}`}>
            <div className="animation-preloader">
                <div className="spinner"></div>
                <div className="txt-loading">
                    {lc.animation.map((l, i) => (
                        <span key={`l-${i}`} data-text-preloader={l} className="letters-loading">{l}</span>))}
                </div>
                <h3 className="text-center">{lc.message}</h3>
                <p className="text-center">{lc.loadMessage}</p>
            </div>
            <div className="loader">
                <div className="row">
                    {lc.animation.map((l, i) => (<div key={`l-${i}`} className="col-3 loader-section section-left">
                        <div className="bg"></div>
                    </div>))}
                </div>
            </div>
        </div>
	);
}
